import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ClickButton } from "components/FormElements";
import Header from "components/Header";
import SubHeader from "components/SubHeader";
import Footer from "components/Footer";
import nftcomictags from "../videos/nftcomictags.mp4";

export default function Processing() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { cartId } = useParams();

  return (
    <div className="min-h-screen flex flex-col" data-reactid={cartId}>
      <Header />
      <SubHeader heading={t("local.redeem.title.main").toString()} />
      <main className="md:px-0 flex-grow relative">
        <video playsInline={true} autoPlay={true} muted={true} controls={false} className="absolute object-none md:object-cover h-full w-full" loop>
          <source src={nftcomictags} type="video/mp4" />
        </video>

        <div className="relative top-0 left-0 bg-black bg-opacity-75 py-10 md:py-40">
          <section className="container mx-auto px-4">
            <h2 className="text-3xl text-white mb-2.5">{t("local.redeem.processing.title.main")}</h2>
            <h3 className="text-4xl md:text-6xl text-white uppercase flex items-center ">
              <span className="grow-0 mr-6">{t("local.redeem.processing.status.main")}</span>
              <svg className="animate-spin h-12 w-12 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </h3>
            <p className="text-white mt-4">{t("local.redeem.processing.content.1")}</p>
            <p className="text-white my-4 max-w-2xl">
              {t("local.redeem.processing.content.2")} {t("local.redeem.processing.content.3")}
            </p>
            <div className="flex flex-col space-y-4 md:max-w-xs">
              <ClickButton handleClick={() => window.location.replace(process.env.REACT_APP_URL_SITE_READER!)} label={t("global.button.reader")} />
              <ClickButton colour={"bg-ct-orange"} handleClick={() => navigate("/")} label={t("global.button.redeemcard")} />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
